function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xfec59a;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;










    var itemsPositionsObject = { dino: { x: 295, y: 206, w: 200, h: 359, n: "dino" }, labirinto_0: { x: 500, y: 51, w: 497, h: 498, n: "labirinto_0" }, labirinto_2: { x: 500, y: 51, w: 497, h: 498, n: "labirinto_2" }, labirinto_1: { x: 500, y: 51, w: 497, h: 498, n: "labirinto_1" }, labirinto: { x: 511, y: 65, w: 476, h: 473, n: "labirinto" }, r: { x: 1014, y: 419, w: 100, h: 98, n: "r" }, l: { x: 1014, y: 308, w: 100, h: 99, n: "l" }, d: { x: 1014, y: 198, w: 100, h: 99, n: "d" }, u: { x: 1014, y: 88, w: 100, h: 99, n: "u" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);

    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 1600);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 1;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(0, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        //   game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 992;
        sprites.btn_gioca.y = 425;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //


    /*
   
        {u:1,d:0,l:0,r:1},{u:0,d:0,l:1,r:1},{u:0,d:0,l:1,r:1},{u:1,d:0,l:1,r:0},{u:1,d:0,l:0,r:1},{u:0,d:0,l:1,r:1},{u:0,d:0,l:1,r:1},{u:1,d:0,l:1,r:1},{u:1,d:0,l:1,r:0}]
    */

    var level0Map = [
        { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 },
        { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }

    ];
    var level1Map = [
        { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 0 },
        { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 1, l: 1, r: 0 },
        { u: 1, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 },
        { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 1, d: 1, l: 0, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }

    ];
    var level2Map = [
        { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 },
        { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 1, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 },
        { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 1, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 0, d: 1, l: 0, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 1, l: 1, r: 0 }, { u: 0, d: 1, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 1, l: 0, r: 0 }, { u: 1, d: 1, l: 0, r: 0 },
        { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }, { u: 1, d: 0, l: 0, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 0, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 1 }, { u: 1, d: 0, l: 1, r: 0 }
    ];
    var grid = [];
    var currentGameMap = [];
    var gameline;
    var levelsMap = {
        level0: level0Map,
        level1: level1Map,
        level2: level2Map
    };
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer = new Container();

    var dinoPosition = { x: 0, y: 8 };
    var gameIndex = 0;
    var sceneElements = {};
    var levelNames = ['0', '1', '2'];
    var directions = ['u', 'd', 'l', 'r'];
    var currentLevelName;
    var currentLevelMap;

    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);


    initScene();

    function initScene() {
        var i, ii;

        var spriteItem;
        var pos;

        var graphics;

        spriteItem = game.sprites.dino;
        pos = positions.dino;
        spriteItem.position.set(pos.x, pos.y);
        container.addChild(spriteItem);
        sceneElements.dino = spriteItem;

        spriteItem = game.sprites.arrows;
        pos = positions.u;
        spriteItem.position.set(pos.x, pos.y);
        container.addChild(spriteItem);
        sceneElements.arrows = spriteItem;



        for (i = 0; i < 3; i++) {
            spriteItem = game.sprites['labirinto_' + i];
            pos = positions['labirinto_' + i];
            spriteItem.position.set(pos.x, pos.y);
            container.addChild(spriteItem);
            sceneElements['labirinto_' + i] = spriteItem;
            sceneElements['labirinto_' + i].alpha = 0;
        }
        for (i = 0; i < 4; i++) {
            var dir = directions[i];
            pos = positions[dir];
            spriteItem = new Graphics();
            spriteItem.position.set(pos.x, pos.y);
            spriteItem.name = dir;
            spriteItem.beginFill(0xffc69b);
            spriteItem.lineStyle(0, 0x000000);
            spriteItem.drawRect(0, 0, pos.w, pos.h);
            spriteItem.endFill();
            spriteItem.interactive = true;
            spriteItem.buttonMode = true;
            sceneElements[dir] = spriteItem;
            spriteItem.alpha = 0;
            buttonsContainer.addChild(spriteItem);
        }
        container.addChild(buttonsContainer);
        pos = positions.labirinto;
        posDx = pos.w / 9;
        posDy = pos.h / 9;
        x0 = posDx / 2;
        y0 = posDx / 2;
        for (i = 0; i < 9; i++) {
            var labX = posDx * i;
            for (ii = 0; ii < 9; ii++) {
                var labY = posDy * ii;
                grid[i + ii * 9] = { x: labX, y: labY };
            }
        }

        var gameline = new Graphics();
        sceneElements.gameline = gameline;
        gameline.position.set(x0 + pos.x, y0 + pos.y);
        container.addChild(gameline);
    }


    function clear() {


    }

    function reset() {
        levelNames = _.shuffle(levelNames);
        gameIndex = 0;
        setState('newLevel');
    }

    function resetLevels() {
        var i, ii;

        for (i = 0; i < 3; i++) {
            sceneElements['labirinto_' + i].alpha = 0;
        }
        for (i = 0; i < 81; i++) {
            currentGameMap[i] = true;
        }
        sceneElements.gameline.clear();

        sceneElements.gameline.lineStyle(8, 0xc34a51);
        sceneElements.gameline.moveTo(grid[72].x, grid[72].y);

    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                resetLevels();


                levelNames.push(levelNames.shift());

                currentLevelName = levelNames[0];
                currentLevelMap = levelsMap['level' + currentLevelName];
                sceneElements['labirinto_' + currentLevelName].alpha = 1;

                // testMap();
                dinoPosition = { x: 0, y: 8 };
                break;
            case 'ready':
                refreshArrows();
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function refreshArrows() {
        var dinoIndex = cToI(dinoPosition);
        currentGameMap[dinoIndex] = false;
        var cell = currentLevelMap[dinoIndex];

        for (i = 0; i < 4; i++) {
            var dir = directions[i];
            var arrow = sceneElements[dir];
            var viable = currentGameMap[indexInDirection(dinoIndex, dir)] && cell[dir] === 1;
            arrow.alpha = viable ? 0 : 0.75;
            arrow.interactive = viable;
        }
    }

    function indexInDirection(index, direction) {
        var p = iToC(index);
        switch (direction) {
            case 'u':
                p.y -= 1;
                break;
            case 'd':
                p.y += 1;
                break;
            case 'l':
                p.x -= 1;
                break;
            case 'r':
                p.x += 1;
                break;
        }
        p.x = p.x < 0 ? 0 :
            p.x > 8 ? 8 :
            p.x;
        p.y = p.y < 0 ? 0 :
            p.y > 8 ? 8 :
            p.y;
        return cToI(p);
    }

    function cToI(point) {
        return point.y * 9 + point.x;
    }

    function iToC(index) {
        return { x: index % 9, y: Math.floor(index / 9) };
    }

    function onClick(e) {

        if (currentState === "ready") {

            var p1 = cToI(dinoPosition);
            var p2 = indexInDirection(p1, e.target.name);
            if (p1 !== p2) {
                sceneElements.gameline.lineTo(grid[p2].x, grid[p2].y);
                dinoPosition = iToC(p2);

                loopSequence = [renderOnce];
                checkProgress(p2);
            }
        }
    }

    function testMap() {
        for (var i = 0; i < 81; i++) {
            var cell = currentLevelMap[i];
            for (var ii = 0; ii < 4; ii++) {
                var dir = directions[ii];
                if (cell[dir] === 1) {
                    var color = dir === 'u' || dir === 'l' ? 0x00ff00 : 0x0000ff;
                    stepLineTo(i, indexInDirection(i, dir), color);
                }
            }
        }

    }

    function stepLineTo(p1, p2, col) {
        //col = col || 0x000000;
        sceneElements.gameline.lineStyle(8, col, 0.5, 1);
        sceneElements.gameline.moveTo(grid[p1].x, grid[p1].y);
        sceneElements.gameline.lineTo(grid[p2].x, grid[p2].y);
    }


    function checkProgress(index) {


        if (index === 8) {
            setState('animating');
            renderer.view.dispatchEvent(new Event('answerOk'));
            setTimeout(okComplete, 1000);
        } else {

            var canContinue = false;
            var cell = currentLevelMap[index];
            for (i = 0; i < 4; i++) {
                var dir = directions[i];
                var viable = currentGameMap[indexInDirection(index, dir)] && (cell[dir] === 1);
                if (viable) {
                    canContinue = true;
                }
            }

            if (canContinue) {

                refreshArrows();

            } else {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                setTimeout(wrongComplete, 1000);
                loopSequence = [renderOnce];
            }

        }



    }

    function okComplete() {

        gameIndex++;
        if (gameIndex < 1) {
            setState('newLevel');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function wrongComplete() {
        gameIndex++;
        theGame.cycleGame();
        loopSequence = [renderOnce];

    }
}